import { render, staticRenderFns } from "./student-track.vue?vue&type=template&id=40e792d1&scoped=true"
import script from "./student-track.vue?vue&type=script&lang=js"
export * from "./student-track.vue?vue&type=script&lang=js"
import style0 from "./student-track.vue?vue&type=style&index=0&id=40e792d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e792d1",
  null
  
)

export default component.exports